<template>
  <transition name="el-fade-in-linear">
    <div class="newsDetail2">
      <router-link to>
        <img
          @click="$router.back(-1)"
          class="backPic"
          src="../../static/images/back.png"
        />
      </router-link>
      <div class="detailTitle">
        科研硬核 | 城市轨道交通，大客流安全管控如何破题？
      </div>
      <div class="detailTitleSecond">深圳北斗应用技术研究院 8月5日</div>
      <div class="line"></div>
      <div class="detailPic">
        <img
          class="newsDetailSize"
          src="../../static/images/newsDetailPic7.png"
        />
        <img
          class="newsDetailSize secondTextPic"
          src="../../static/images/newsDetailPic8.png"
        />
      </div>
      <div class="detailTitleText">
        “随着城市轨道交通高速发展，轨道交通客流呈现井喷式增长，随之而来的大客流安全管控压力得到全社会的高度关注。基于现有大客流安全管控中的客流监控滞后，缺乏预警手段、管控手段单一等痛点，对如何通过技术手段提高轨道交通的风险感知预警能力，如何科学高效地处置地铁大客流问题进行分析研究，旨在为城市轨道交通行业的大客流管控提供创新思路与研究实践。”
      </div>
      <div class="detailTitleText">
        近年来，北斗院聚焦智慧安防的研究与实践，大客流安全管控是其中的重点内容之一。“基于AFC、视频、WiFi的客流分析引擎，对城市轨道交通下宏观客流、微观客流进行实时感知、多维分析，建立一个集实时客流监测、精准客流分析的全区域、全要素、全流程的客流安全风险感知体系。”
      </div>
      <div class="detailTitleText">
        大客流的管控通过落地应用取得了明显成效：“基于多维感知手段的城市轨道交通大客流安全风险感知和预测预警技术目前已应用于深圳、广州、宁波等城市，在国庆节、烟花节、灯光节等节假日和重大活动期间发挥了有效的监测预警能力。曾参与某市灯光节期间客流监测预警，通过综合AFC、视频分析、WiFi等手段，提前30分钟预知灯光节所在周边车站大客流爆发时间及站点范围，并结合历史客流数据对大客流规模进行估计，对客流安全风险等级进行评估，综合客流主要来源去向，输出客流组织预案，辅助公安机关和运营企业在半小时内完成现场20万人次客流的疏散。”
      </div>
      <div class="detailTitleText">
        以上内容节选自论文《城市轨道交通大客流安全管控技术研究与实践》，该文由北斗院联合创始人闫茜联合浙江省宁波市公安局轨道交通治安分局周梦麟撰写，发表在由公安部主管、公安部第一研究所主办的警用技术和装备领域的权威性刊物《警察技术》2020年第4期。
      </div>
      <div class="detailTitleText">
        未来，随着公共交通的快速发展，北斗院将继续保持在大客流风险防控领域的研究，综合技防、人防、物防构建大客流安全风险管控体系，全面支撑轨道交通大客流风险的立体防控，提高城市轨道交通安全管控能力，为市民安全出行提供基础保障。除此以外，北斗院还将在安防其他领域加大投入，保持在科研领域的领先地位，为公共交通安全出行贡献出自己的力量。
      </div>
      <div class="detailTitleLittle">警察技术杂志简介</div>
      <div class="detailTitleText">
        由公安部主管、公安部第一研究所主办的国内唯一全面报道警用技术与装备的专业性权威期刊。杂志1985年创刊以来，始终致力于引领警用尖端技术、推广优秀执法方案、介绍警用装备产品、普及警用科技知识，多年来同公安部各相关业务局建立了良好的合作关系，一直活跃在公安装备、信息化、通信、信息网络安全等领域，为提高警力和科技强警作出了卓越贡献
      </div>
      <div class="newsDetailFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>

<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  components: {
    Foot,
  },
  methods: {},
};
</script>
<style scoped>
@import "./NewsDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/NewsDetail3.vue